import React, { useEffect, useState } from "react";

/* -------- packages -------- */
import {  Modal, ModalHeader, ModalBody } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { toast, ToastContainer } from "react-toastify";
import { fetchCommentsRequest, fetchGroupsRequest, updateCommentRequest, deleteCommentRequest } from "../../../store/actions";
/* -------- ------- -------- */

/* -------- intern functions -------- */
/* -------- ------- -------- */

export default function CommentsModal ({linkedEntityId, linkedEntityModel, isModalOpen, setModalOpen}) { // isModalOpen (BOOLEAN), setModalOpen (useState Function(true/false))
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const navigate = useNavigate();
      const user = useSelector(state => state.Login.user);
    
    const users = useSelector(state => state.Users);
    const Comments = useSelector(state => state.Comments);
    
    const [commentsModalValues, setCommentsModalValues] = useState([]);
    
    //New comment state
    const [newComment, setNewComment] = useState('');
    const [isPrivateNewComment, setIsPrivateNewComment] = useState(false);

    


    function getAllData (updatedComment) {
        dispatch(fetchCommentsRequest())

        let commentsTemp = []

        Comments.comments.map( (data) => {
            if(data.linkedEntityModel == linkedEntityModel && linkedEntityId == data.linkedEntityId) {

                if(!updatedComment || updatedComment?.id != data.id) {
                    commentsTemp.push(data)
                } 
                
                if (Comments.error == null && updatedComment?.id == data.id) {
                    commentsTemp.push(updatedComment)
                }
            }
        })

        setCommentsModalValues(commentsTemp.reverse()) // reverse function to cronological order
    }

    useEffect( () => { // useEffect on open modal
        getAllData()
    }, [dispatch, isModalOpen])

    useEffect( () => { // useEffect on comments update
        getAllData()
    }, [Comments.comments.length])



    /* ----------------- Logical & Intern Components ----------------- */
    
        const handlePostComment = (comment) => {
            const error = t('noFileSelectioned')
            if (!newComment) {
                return toast.warning(error, {
                position: "top-center",
                autoClose: 5000,
                draggable: true,
                });
            }
            const newCommentData = {
                userId: user.id,
                linkedEntityModel: linkedEntityModel,
                linkedEntityId: linkedEntityId,
                comment: comment,
                isPrivate: isPrivateNewComment
            }

            dispatch(updateCommentRequest(newCommentData, navigate));
            dispatch(fetchCommentsRequest());

            if(linkedEntityModel === 'ProjGroup') {
                dispatch(fetchGroupsRequest());
            }
            setNewComment('');
        }
        
        const handleDeleteComment = (id) => {
            if(id && !isNaN(id)){
                dispatch(deleteCommentRequest(id))
            }
        }
    /* ---------------------------------------------------------------------- */
        

        const CommentElement = ({ comment, commentId, userId, isPrivate, createdAt }) => {
            // Edit comment state
            const [commentToEdit, setCommentToEdit] = useState({comment: '', isPrivate: false, userId: 0, commentId: 0, createdAt: 0});


            const handleEditComment = ({comment, isPrivate, userId, commentId, createdAt}, cancelEdit) => {
            
                if(cancelEdit) {
                    return setCommentToEdit({comment: '', isPrivate: false, userId: 0, commentId: 0, createdAt: 0})
                }
    
                if(userId !== user.id) {
                    return toast.warning(t('notAllowed'), {
                        position: "top-center",
                        autoClose: 5000,
                        draggable: true,}
                    )
                }
                
                setCommentToEdit({comment, isPrivate, userId, commentId, createdAt})
            }

            const handlePostEditedComment = () => {

                if(commentToEdit.comment == '') {
                    return toast.warning(t('is_null'), {
                        position: "top-center",
                        autoClose: 5000,
                        draggable: true,
                    });
                }
    
                const editedCommentData = {
                    userId: user.id,
                    id: commentToEdit.commentId,
                    linkedEntityModel: linkedEntityModel,
                    linkedEntityId: linkedEntityId,
                    comment: commentToEdit.comment,
                    isPrivate: commentToEdit.isPrivate
                }
    
                dispatch(updateCommentRequest(editedCommentData, navigate));
                getAllData(editedCommentData)
            }

            useEffect( () => { // useEffect on open modal and on upodate comments
                if(commentToEdit.commentId !== commentId) {
                    setCommentToEdit({}, true)
                }
            }, [getAllData])
        
            return (
                <li className="event">
                    
                    <p className="createAt">
                        {moment(createdAt).format('DD MMMM YYYY HH:mm') + ' ' + t('by') + ' '}
                        <span className="customDynamicColor">
                            {
                                users.users.map((user) => {
                                    if (user.id === userId) {
                                        return user.fullName
                                    }
                                })}
                        </span>
                    </p>
                    {(commentToEdit && commentToEdit.commentId === commentId) ?
                    (
                        <>
                        <div className="commentDiv">
                            <div className="commentEditArea">
                                <textarea type="notesheet" className="form-control commentInput updateCommentTextArea" value={commentToEdit.comment} onChange={(e) => setCommentToEdit({...commentToEdit, comment: e.target.value})}/>

                                <div className={'btnsContainer btnsContainerEdit' + (commentToEdit.comment ? ' editArea' : '')}>
                                        <i className={'bx bx-lock iconBtnModal lock ' + (commentToEdit.isPrivate ? ' customDynamicColor' : '')} onClick={() => setCommentToEdit({...commentToEdit, isPrivate: true})}></i>
                                        <i className={'mdi mdi-lock-open-variant-outline iconBtnModal unlock'  + (!commentToEdit.isPrivate ? ' customDynamicColor' : '')} onClick={() => setCommentToEdit({...commentToEdit, isPrivate: false})} ></i>
                                </div>
                            </div>
                            <span className="updateCommentLocks">
                                    
                                    {(commentToEdit.isPrivate) ?
                                    <i className='bx bx-lock iconTable lock' ></i> :
                                    <i className='mdi mdi-lock-open-variant-outline iconTable unlock' ></i>
                                    }
                                </span>
                        </div>
                        <span className="commentEditDelContainer">
                            <i className={'mdi mdi-content-save-edit-outline iconComment saveCommentIcon'} onClick={ () => {handlePostEditedComment()}} title={t('validate')}/>
                            <i className={'mdi mdi-close iconComment cancelCommentIcon'} onClick={() => handleEditComment({}, true)} title={t('cancel')} ></i>
                        </span>
                        </>
                    ) : (
                        <>
                        <div className="commentDiv">
                            
                            <p className="commentText">
                                {comment}
                            </p>
                            {(isPrivate) ?
                            <i className='bx bx-lock iconTable lock' ></i> :
                            <i className='mdi mdi-lock-open-variant-outline iconTable unlock' ></i>
                            }
                        </div>
                        <span className="commentEditDelContainer">
                            <i className='bx bx-edit-alt iconComment editCommentIcon' onClick={ () => { handleEditComment({comment, isPrivate, userId: userId, commentId, createdAt})}} ></i>
                            <i className="bx bx-trash iconComment deleteCommentIcon" onClick={() => { handleDeleteComment(commentId) }} />
                        </span>
                        </>
                    )

                    }
                </li>
            )
            
        }
    /* ---------------------------------------------------------- */



    return (
      <Modal isOpen={isModalOpen} toggle={() => setModalOpen.setIsCommentsModalOpen(false)} centered={true} size={'xl'} scrollable={true}>
        <ModalHeader toggle={() => setModalOpen.setIsCommentsModalOpen(false)}>{t('comments')}</ModalHeader>
        <div className="groupsModal">
        <ModalBody>
            <div className="container commentsModal">
                <div className="card">
                    <div className="card-body">
                        <div id="content">
                            {commentsModalValues && commentsModalValues.map((data, index) => {
                                let lastIndex = (index == commentsModalValues.length - 1)
                                return (
                                    <ul className={lastIndex ? "timeline active" : "timeline"}
                                        key={index}>

                                        <span className={lastIndex ? "lastComment" : "line"}>
                                            <CommentElement 
                                                comment={data.comment}
                                                commentId={data.id}
                                                isPrivate={data.isPrivate}
                                                createdAt={data.createdAt}
                                                userId={data.SelfComments?.id || data.userId}
                                            />
                                        </span>

                                    </ul>
                                    )
                                })
                            }

                            {
                            (commentsModalValues == null) <= 0 && <div className="card"></div>
                            }

                        </div>
                    </div>
                    <div className="card-footer customComponentsBg">
                        <div className="textAreaContainer">
                                    <p>{t('newComment')}</p>
                                    <textarea type="notesheet" className="form-control commentInput" value={newComment} onChange={(e) => setNewComment(e.target.value)}/>
                        </div>
                        <div className={"btnsContainer"}>
                                    <i className={'bx bx-send iconBtnModal bx-rotate-270'} onClick={ () => {handlePostComment(newComment,
                                                    (commentsModalValues && 
                                                        commentsModalValues[0] && 
                                                        commentsModalValues[0].linkedEntityId) || 
                                                        undefined )}} 
                                                        title={t('submit')}
                                                />
                                    <i className={'bx bx-lock iconBtnModal lock ' + (isPrivateNewComment ? ' customDynamicColor' : '')} onClick={() => setIsPrivateNewComment(true)}></i>
                                    <i className={'mdi mdi-lock-open-variant-outline iconBtnModal unlock'  + (!isPrivateNewComment ? ' customDynamicColor' : '')} onClick={() => setIsPrivateNewComment(false)} ></i>

                        </div>
                    </div>
                </div>
            </div>
        </ModalBody>
        </div>
      </Modal>
    )

}